export default "__VITE_ASSET__Cr9y6$$1__"